import React, { useContext, useEffect, useState } from 'react'
import TransferTimeline from './progressTimeLine';
import ViewActions from './ViewActions';
import { generateProgressSteps, getProgressStepList, logsList, progressStepList } from './constant';
import { endpoint } from 'views/pages/manage/common/constant';
import { fetchAllPostPromisedData,dropdownMapping } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getApprovalRequests } from 'redux/concessionApproval/actions';
import BmApprovalAction from './BmApprovalAction';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { getRequests } from 'modules/studentTransfer/transferApproval/utils';
import { useGetPermissions } from 'layouts/customHook';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getRoleId } from 'modules/studentTransfer/transferApproval/utils';
import { PermissionContext } from 'appContext';
import { getConfigs } from './../studentTransfer/transferSetup/transferApprovalConfig/services';
import { approverActionAndDispValueMapping, getApprovalPermissions } from './../studentTransfer/transferApproval/utils';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import { getDropdownIdsFromSelectArray } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
const ProgressAndActionsWrapper = ({ psid, details, setLoader: setLoading, isBmApproval, applicationId, id }) => {
    const [isApproval, setIsApproval] = useState()
    const permissions = useContext(PermissionContext);
    const userPermissions = useGetPermissions("studentTransferApproval");
    const isApproverPermission = checkPermission(userPermissions, "A");
    const [approvalActionSuccessDialogOpen, setApprovalActionSuccessDialogOpen] = useState(false);
    const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState({});
    const [isApprovalLevelL2, setIsApprovalLevalL2] = useState(false)
    useEffect(() => {
        permissions && getApproval()
    }, [permissions])
    const getApproval = async () => {
        try {
            setLoading(true);
            const res = await getRequests({ filters: { applicationId } }); //calling dashboard api
            if (res?.code == 200) {
                const p = await Promise.all([getRoleId(permissions?.roleType), dropdownMapping( //calling role and all business area api
                    endpoint.businessArea.getAllActiveV2, 
                    "businessAreaDispValue",
                    "id",
                    "businessAreaDesc"
                )]);
                const businessAreas = p[1];
                const roleId=p[0];
                const approvalConfigs = (await getConfigs({ businessAreas: getDropdownIdsFromSelectArray(businessAreas) }))?.data ?? []; // passing all user assigned bu so that he can get particular configs
                const { isL1Approver, isL2Approver, l1ApprovalRoles, l2ApprovalRoles } = getApprovalPermissions(approvalConfigs, roleId, res?.data?.transferDetailsDtoList?.[0],businessAreas); // method that return permission whether use has l1 or l2 or l3 permission
                const approvalStatus = res?.data?.transferDetailsDtoList?.[0]?.approvalStatus
                const isL1Pending = approvalStatus === 'L1_PENDING';
                const isL2Pending = approvalStatus === 'L2_PENDING';
                const isApproval = (isL1Pending && isL1Approver || isL2Pending && isL2Approver)
                setIsApprovalLevalL2(l2ApprovalRoles.length > 0)
                setIsApproval(isApproval);
            }
        } catch (err) {
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    }
    const updateStatus = async ({
        applicationId,
        approvalAction,
        remark = "",
    }) => {
        try {
            setLoading(true);
            const reqObj = { approvalAction, remarks: remark, applicationId };
            const resp = await fetchAllPostPromisedData(
                `${endpoint.transferApproval.updateStatus}`,
                reqObj
            );
            if (resp?.code === 200) {
                const actionDispValue = approverActionAndDispValueMapping[approvalAction];
                setApprovalActionSuccessDialogOpen(true);
                setApprovalActionSuccessDialogInfo({
                    heading: `Transfer request no. ${id} has been ${actionDispValue}.`,
                    subHeading: `Request has been ${actionDispValue} for PSID ${psid}.`
                })

                successToast("Request completed successfully!");
                await getApproval()
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const steps = generateProgressSteps(getProgressStepList({ hasL2Approval: true, transferPolicy: details?.details?.transferPolicy }), details?.logs ?? [])
    return (
        <div>
            {isApproval && isApproverPermission && <BmApprovalAction updateStatus={updateStatus} transferOutAppId={applicationId} id={id} />}
            <TransferTimeline
                steps={steps}
            />
            {!isBmApproval && <ViewActions psid={psid} details={details?.details} steps={steps} />}
            <ApprovalSentSuccessDialog
                open={approvalActionSuccessDialogOpen}
                setOpen={setApprovalActionSuccessDialogOpen}
                heading={approvalActionSuccessDialogInfo?.heading}
                subHeading={approvalActionSuccessDialogInfo?.subHeading}

            />
        </div>

    )
}
export default ProgressAndActionsWrapper;